<app-company-selection-list
  [endpoints]="endpoints"
  searchInputId="company-search"
  (selectCompany)="onClick($event)"
  (adminPanelClick)="onAdminPanelClick()"
></app-company-selection-list>
